import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { jobSyncQueryKeys } from "../query-keys";
import {
  PaginatedVacancySyncOverviewResponse,
  VacancySyncState,
} from "../types";

import { instance } from "@/lib/axios/instance";

type UseIndeedJobSyncVacanciesOverviewProps = {
  clientId: string;
  page?: number;
  pageSize?: number;
  syncState?: VacancySyncState | null;
  tenantId?: string;
  integrationName: string;
  enabled?: boolean;
};

export function useIndeedJobSyncVacancies({
  clientId,
  tenantId,
  page = 1,
  pageSize = 10,
  syncState = null,
  integrationName,
  enabled = true,
}: UseIndeedJobSyncVacanciesOverviewProps): UseQueryResult<
  PaginatedVacancySyncOverviewResponse,
  AxiosError
> {
  return useQuery({
    queryKey: jobSyncQueryKeys.vacanciesList({
      integrationName,
      clientId,
      syncState,
      page,
      pageSize,
    }),
    queryFn: () =>
      instance
        .get<PaginatedVacancySyncOverviewResponse>(
          `/api/v2/Integrations/${integrationName}/job-sync/Vacancies`,
          {
            params: {
              clientId: clientId ?? undefined,
              tenantId: tenantId ?? undefined,
              page,
              pageSize,
              ...(syncState !== null && { syncState }),
            },
          }
        )
        .then((res) => res.data),
    enabled: enabled && !!integrationName,
    refetchOnReconnect: false,
    staleTime: 20 * 60 * 1000,
  });
}
